import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SelectPlayer } from './pages/SelectPlayer';
import { Game } from './pages/Game';
import { Admin } from './pages/Admin';
import { Decisions } from './pages/Admin/Decisions';
import { AdminLogin } from './pages/Admin/Login';
import { AdminSetPasswordPage } from './pages/Admin/SetPasswordPage';
import { RequireAdminAuth } from './pages/Admin/RequireAdminAuth';
import { End } from './pages/End';
import { AdminLayout } from './pages/Admin/AdminLayout';
import { AdminCriteriaPage } from './pages/Admin/AdminCriteriaPage';
import { AdminImpactsPage } from './pages/Admin/AdminImpactsPage';
import { AdminVerbatimsPage } from './pages/Admin/AdminVerbatimsPage';
import { AdminPlayerTextsPage } from './pages/Admin/AdminPlayerTextsPage';
import { AdminProfilePage } from './pages/Admin/AdminProfilePage';
import { AdminUsersPage } from './pages/Admin/AdminUsersPage';
import { AdminSessionStatsPage } from './pages/Admin/AdminSessionStatsPage';
import { AdminProgramsPage } from './pages/Admin/AdminProgramsPage';
import { AdminProgramFormPage } from './pages/Admin/AdminProgramFormPage';

// Component to handle smart routing based on localStorage
const SmartRedirect: React.FC = () => {
  const teamName = localStorage.getItem('team_name');
  const currentRound = localStorage.getItem('current_round');
  const sessionCode = localStorage.getItem('session_code');

  // If team is selected and round exists, go to game
  if (teamName && currentRound) {
    return <Navigate to={sessionCode ? `/game/${sessionCode}` : '/game'} replace />;
  }

  // Otherwise go to select player
  return <Navigate to={sessionCode ? `/select-player/${sessionCode}` : '/select-player'} replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default route - smart redirect */}
        <Route path="/" element={<SmartRedirect />} />

        {/* Select player page - with optional session code in path */}
        <Route path="/select-player/:sessionCode?" element={<SelectPlayer />} />

        {/* Game page */}
        <Route path="/game/:sessionCode?" element={<Game />} />

        {/* End page */}
        <Route path="/end/:sessionCode?" element={<End />} />

        {/* Admin pages */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/set-password" element={<AdminSetPasswordPage />} />
        <Route element={<RequireAdminAuth />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/sessions" replace />} />
            <Route path="sessions" element={<Admin />} />
            <Route path="programs" element={<AdminProgramsPage />} />
            <Route path="programs/new" element={<AdminProgramFormPage />} />
            <Route path="programs/:id/edit" element={<AdminProgramFormPage />} />
            <Route path="sessions/stats" element={<AdminSessionStatsPage />} />
            <Route path="criterias" element={<AdminCriteriaPage />} />
            <Route path="impacts" element={<AdminImpactsPage />} />
            <Route path="verbatims" element={<AdminVerbatimsPage />} />
            <Route path="player-texts" element={<AdminPlayerTextsPage />} />
            <Route path="profile" element={<AdminProfilePage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="decisions/:teamNumber?" element={<Decisions />} />
          </Route>
        </Route>

        {/* Catch-all route - smart redirect */}
        <Route path="*" element={<SmartRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
